import types from '../actionTypes';

export const openModal = (content, closeBtn, onCloseCallback) => ({ type: types.OPEN_MODAL, content, closeBtn, onCloseCallback });
export const closeModal = () => ({ type: types.CLOSE_MODAL });